import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { get } from '../../../lib/wfApi';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Link } from 'react-router-dom';
import * as listActions from '../DealList.actions';
import * as modalActions from '../../ModalAlert/ModalAlert.actions';
import EditIcon from '../../../assets/icons/EditIcon/EditIcon';
import DeleteIcon from '../../../assets/icons/DeleteIcon/DeleteIcon';

const DealListItem = ({ data, ...props }) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const store = useSelector(store => store);
  const currentLang = store.app.selectedLanguage;
  const storeId = store.app.storeId;
  const perPage = store.list.perPage;
  const deleteComplete = store.list.requestComplete;
  const [status, setStatus] = useState('');
  const [activations, setActivations] = useState('');
  const [allowDelete, setAllowDelete] = useState(true);

  useEffect(() => {
    if (!activations && data.deal_id > 0) {
      const limit = data.quantity_limit;

      const getDealStatus = (redeemed) => {
        if (data.state === 'expired') return t('table_cell_status_expired');
        else if (data.state === 'withdrawn') return t('table_cell_status_withdrawn');
        else if (limit > 0 && redeemed >= limit) return t('table_cell_status_unavailable');
        else if (moment(new Date(data.starts_at)).startOf('day') > moment(new Date()).startOf('day')) return t('table_cell_status_pending');
        else return t('table_cell_status_active');
      }

      get(`deals/${data.deal_id}/redemption-status`, {}, {})
        .then(response => {
          return response.json();
        })
        .then(json => {
          const redeemed = json.data.redeemed_count;
          setActivations((limit > 0) ? `${redeemed}/${limit}` : `${redeemed}`);
          setStatus(getDealStatus(redeemed));
        })
        .catch(() => {
          console.log('ERROR');
        })
    }
  }, [activations, status, data, t]);

  useEffect(() => {
    setAllowDelete(status === t('table_cell_status_pending'));
  }, [status, allowDelete, t])

  useEffect(() => {
    if (deleteComplete) {
      dispatch(listActions.reset());
      dispatch(listActions.getDealList(storeId, perPage));
    }
  }, [dispatch, deleteComplete, storeId, perPage]);

  const deleteHandler = () => {
    const alertProps = {
      header: '',
      body: t('alert_delete_msg'),
      ok_button: t('alert_delete_yes'),
      cancel_button: t('alert_delete_no'),
      callback: onDelete
    }
    dispatch(modalActions.setupModal(alertProps, true));
  }

  const onDelete = (confirm) => {
    if (confirm) dispatch(listActions.deleteDeal(data.deal_id))
  }

  return (
    <tr className="coral-Table-row editable" { ...props }>
      <td className="coral-Table-cell">
        { status }
      </td>
      <td className="coral-Table-cell">
        { data.title }
      </td>
      <td className="coral-Table-cell">
        <span>
          { new Intl.DateTimeFormat(currentLang, {
              year: '2-digit', 
              month: '2-digit', 
              day: '2-digit'
            }).format(new Date(data.starts_at.replace('Z',''))) }
        </span> - 
        <span style={{paddingLeft: '3px'}}>
          { new Intl.DateTimeFormat(currentLang, {
              year: '2-digit', 
              month: '2-digit', 
              day: '2-digit'
            }).format(new Date(data.ends_at.replace('Z',''))) }
        </span>
      </td>
      <td className="coral-Table-cell">
        { activations }
      </td>
      <td className="coral-Table-cell button-container-left">
        <Link className="table-button" to={`${data.deal_id}/edit`}>
          <EditIcon
            width="12px"
            height="12px"
            fill="#000"
          />
        </Link>
      </td>
      <td className="coral-Table-cell button-container-right">
        <button className="table-button" onClick={ deleteHandler } style={{ display: (allowDelete) ? 'block' : 'none' }}>
          <DeleteIcon
            width="12px"
            height="12px"
            fill="#da291c"
          />
        </button>
      </td>
    </tr>
  )
}

DealListItem.propTypes = {
  data: PropTypes.shape({
    activations: PropTypes.string,
    deal_id: PropTypes.number,
    ends_at: PropTypes.string,
    quantity_limit: PropTypes.number,
    starts_at: PropTypes.string,
    state: PropTypes.string,
    title: PropTypes.string
  })
}

DealListItem.defaultProps = {
  data: {
    activations: '0',
    deal_id: 0,
    ends_at: '2000-01-01T00:00:00+00:00',
    quantity_limit: 0,
    starts_at: '2000-01-01T00:00:00+00:00',
    state: '',
    title: ''
  }
}

export default DealListItem;